import { PTag, PTagProps } from '@porsche-design-system/components-react';
import { useTranslation } from 'react-i18next';

import { NAMESPACES } from '@/config/i18n';
import { SupportRequestStatus } from '@/graphql';

const STATUS_COLOR: Record<SupportRequestStatus, PTagProps['variant']> = {
  [SupportRequestStatus.Closed]: 'success-frosted',
  [SupportRequestStatus.InProgress]: 'info-frosted',
  [SupportRequestStatus.Open]: 'warning-frosted',
};

type SupportRequestStatusTagProps = {
  status: SupportRequestStatus;
} & PTagProps;

export const SupportRequestStatusTag = ({
  status,
  ...props
}: SupportRequestStatusTagProps) => {
  const { t } = useTranslation(NAMESPACES);

  return (
    <PTag {...props} variant={STATUS_COLOR[status]}>
      {t(`supportRequest.statusValues.${status}`)}
    </PTag>
  );
};
